import React, { createContext, useContext, ReactNode } from 'react';
import { Firestore } from 'firebase/firestore';
import { FirebaseStorage } from 'firebase/storage';
import { db, storage } from '../firebase';

interface RestaurantDatabaseContextType {
  database: Firestore;
  storage: FirebaseStorage;
  hotelId: string;
  restaurantId: string;
  getCollectionPath: (collectionName: string) => string;
}

const RestaurantDatabaseContext = createContext<RestaurantDatabaseContextType | undefined>(undefined);

interface RestaurantDatabaseProviderProps {
  children: ReactNode;
  hotelId: string;
  restaurantId: string;
}

export function RestaurantDatabaseProvider({ children, hotelId, restaurantId }: RestaurantDatabaseProviderProps) {
  const getCollectionPath = (collectionName: string): string => {
    return `hotels/${hotelId}/${collectionName}`;
  };

  return (
    <RestaurantDatabaseContext.Provider
      value={{
        database: db,
        storage,
        hotelId,
        restaurantId,
        getCollectionPath,
      }}
    >
      {children}
    </RestaurantDatabaseContext.Provider>
  );
}

export function useRestaurantDatabase() {
  const context = useContext(RestaurantDatabaseContext);
  if (context === undefined) {
    throw new Error('useRestaurantDatabase must be used within a RestaurantDatabaseProvider');
  }
  return context;
}
